import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card.jsx";
import { Skeleton } from "../../../components/ui/skeleton.jsx";
import { TabsContent } from "@/components/ui/tabs.jsx";

const SecretShopperSkeleton = () => {
    const SkeletonInfoCard = () => (
        <div className="flex items-center space-x-3 bg-gray-50 hover:bg-gray-100 transition-colors p-3 rounded-lg justify-between">
            <div className="flex gap-2">
                <div className="flex-shrink-0">
                    <Skeleton className="h-5 w-5" />
                </div>
                <div className="flex flex-col gap-2">
                    <div className="text-sm font-bold text-gray-500">
                        <Skeleton className="h-4 w-20" />
                    </div>
                    <div className="text-base font-medium">
                        <Skeleton className="h-6 w-32" />
                    </div>
                </div>
            </div>
            <Skeleton className="h-10 w-10" />
        </div>
    );

    return (
        <TabsContent value="secret-shopper" className="gap-2">
            <Card className="w-full max-w-7xl mx-auto shadow-lg">
                <CardHeader>
                    <CardTitle className="text-xl font-semibold">
                        <Skeleton className="h-6 w-64" />
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <SkeletonInfoCard />
                        <SkeletonInfoCard />
                        <SkeletonInfoCard />
                        <SkeletonInfoCard />
                    </div>
                </CardContent>
            </Card>
        </TabsContent>
    );
};

export default SecretShopperSkeleton;